import React from 'react';
import AppRolesService from "../../General/services/AppRolesService";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import styles from './CreateCustomer.module.scss';
import CreateCustomerForm from "../components/CreateCustomerForm";

function CreateCustomer() {
    const { accounts } = useMsal();
    const isAuthenticated = useIsAuthenticated();

    const canConfigure = AppRolesService.canUserConfigureACC(accounts, isAuthenticated);
    if (!canConfigure) {
        return <h3 style={{ color: 'red' }}>You do not have permission to create customers.</h3>;
    }

    return (
        <div className={styles.PageContainer}>
            <div className={styles.PageHeader}>
                <h2 className={styles.PageTitle}>Create ACC Customer</h2>
                <p className={styles.PageSubtitle}>Provision a new Care Compliance customer environment</p>
            </div>
            <CreateCustomerForm />
        </div>
    );
}

export default CreateCustomer;
